import { useEffect } from "react";

import UseRequestAnimation from "@/components/UseRequestAnimation";

export default function TimeBox({
  active,
  show,
  setValue,
}: {
  active: boolean;
  show?: boolean;
  setValue?: (value: number) => void;
}) {
  const { seconds, status, setStatus, reset } = UseRequestAnimation();

  useEffect(() => {
    if (active) {
      reset();
      setStatus(() => new Date());
    } else {
      reset();
      setValue(null);
      reset();
    }
  }, [active]);

  useEffect(() => {
    if (seconds >= 0) {
      setValue(seconds);
    }
  }, [seconds]);

  return active && show && <>{seconds}</>;
}
